/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import axios from 'axios';
import { SecurityHelper as SecurityUtils } from 'sarsaparilla';
import { AVAILABILITY_ALERT_BASE_PATH } from '../constants';

const instance = axios.create({
    baseURL: `${process.env.API}${AVAILABILITY_ALERT_BASE_PATH}`,
});

const authInstance = axios.create({
    baseURL: `${process.env.API}${AVAILABILITY_ALERT_BASE_PATH}`,
    headers: {
        Authorization: SecurityUtils.getAuthHeader(),
    },
});

authInstance.interceptors.request.use((config) => {
    const newConfig = { ...config };
    newConfig.headers.Authorization = SecurityUtils.getAuthHeader();
    return newConfig;
});

export const availAlertAxios = instance;
export const authAvailAlertAxios = authInstance;
